import QRCode from "qrcode";
import JSZip from "jszip";
import { saveAs } from "file-saver";
/** 下载激活码二维码 */
export const downLoadActivationCode = async (codeList: string[]) => {
    if (!codeList?.length) return;
    const zip = new JSZip();
    const downloadUrl = import.meta.env.VITE_APP_QRCODE_DOWNLOAD_URL;
    try {
        for (const code of codeList) {
            const url = `${downloadUrl}?bizType=activationCode&businessId=${code}`;
            const imgUrl = await QRCode.toDataURL(url, { width: 500, margin: 0 });
            const response = await fetch(imgUrl);
            if (!response.ok) {
                console.error(`下载失败: ${response.status} ${response.statusText}`);
                return;
            }
            // 转换为Blob
            const blob = await response.blob();

            const fileName = `激活码${code}`;

            // 添加到ZIP
            zip.file(`${fileName}.png`, blob);
        }

        // 生成ZIP文件并触发下载
        const content = await zip.generateAsync({ type: "blob" });
        saveAs(content, "激活码");
    } catch (e: unknown) {
        console.error("下载失败：" + e);
    }
};
